import request from "./request";
import baseUrl from "./baseUrl";

// this is for globally used APIs only

export default {
  login: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/login", params, { hideLoadingSpinner: false }),
  verifyLoginOtp: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/login/verify-otp", params, { hideLoadingSpinner: false }),
  verifyLoginTotp: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/login/totp", params, { hideLoadingSpinner: false }),
  setupStaffMfa: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/mfa/setup", params, { hideLoadingSpinner: false }),
  confirmStaffMfa: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/mfa/confirm", params, { hideLoadingSpinner: false }),
  staffStepUp: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/step-up", params, { hideLoadingSpinner: true }),
  resendLoginOtp: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/login/resend-otp", params, { hideLoadingSpinner: false }),
  sendPasswordResetOtp: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/reset-password/send-otp", params, { hideLoadingSpinner: true }),
  resetPassword: (params = {}) => request.post(baseUrl.uc + "/uc/v1/bo/reset-password", params),
  setDynamicToken() {
    return Promise.resolve(null)
  },
  imageUpload: async (params = {}) => {
    const fd = new FormData()

    for (let index = 0; index < params.files.length; index++) {
      const element = params.files[index]
      fd.append('files', element)
    }

    const result = await request.post(`${baseUrl.main}/cs/v1/uploads/files`, fd, { hideLoadingSpinner: true })
    if (result && result.data && !result.data.path && result.data.paths) {
      result.data.path = result.data.paths
    }
    return result
  }
}
